import { isAccessRedirectError } from "@lib/access/access";

import * as backend from "../api";

const changeLocale = async (locale) => {
    try {
        await backend.updateUser({
            locale,
        });
    } catch (error) {
        if (isAccessRedirectError(error)) return;
        // Spellbook already reports ordinary API errors; keep the local language change.
        // Raven.captureException(error);
    }
    localStorage.setItem(`side_team_locale`, locale);
    window.location.reload(false);
};

export default changeLocale;
